const AUTH_USER_KEY = "admin_user_profile";

const notifyAuthChange = () => {
  window.dispatchEvent(new Event("auth-profile-changed"));
};

export const normalizeRoleName = (role) => {
  if (typeof role === "string") {
    return role.trim();
  }

  if (role && typeof role === "object") {
    return String(role.name || role.roleName || role.role || "").trim();
  }

  return "";
};

export const isAdminRole = (role) =>
  normalizeRoleName(role).toLowerCase() === "admin";

const extractRoutePermissions = (user) => {
  if (!user || typeof user !== "object") {
    return null;
  }

  const direct = user.routePermission || user.routePermissions;
  if (Array.isArray(direct)) {
    return direct;
  }

  if (user.role && typeof user.role === "object") {
    const nested = user.role.routePermission || user.role.routePermissions;
    if (Array.isArray(nested)) {
      return nested;
    }
  }

  return null;
};

const extractUser = (response) => {
  const data = response?.data ?? response;

  if (Array.isArray(data)) {
    return data[0] || null;
  }

  if (data && typeof data === "object") {
    if (data.user && typeof data.user === "object") {
      return data.user;
    }

    return data;
  }

  return null;
};

export const setAdminProfile = (response) => {
  const user = extractUser(response);

  if (!user || typeof user !== "object") {
    return null;
  }

  const profile = {
    firstName: user.firstName || "",
    lastName: user.lastName || "",
    email: user.email || "",
    role: normalizeRoleName(user.role),
    userId: user.userId || user._id || user.id || "",
    routePermissions: extractRoutePermissions(user),
  };

  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(profile));
  localStorage.setItem("admin_logged_in", "true");
  notifyAuthChange();
  return profile;
};

export const updateStoredRoutePermissions = (routePermissions) => {
  const profile = getAdminProfile();

  if (!profile) {
    return null;
  }

  const nextProfile = {
    ...profile,
    routePermissions: Array.isArray(routePermissions) ? routePermissions : [],
  };

  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(nextProfile));
  notifyAuthChange();
  return nextProfile;
};

export const getAdminProfile = () => {
  const serializedProfile = localStorage.getItem(AUTH_USER_KEY);

  if (!serializedProfile) {
    return null;
  }

  try {
    return JSON.parse(serializedProfile);
  } catch (error) {
    localStorage.removeItem(AUTH_USER_KEY);
    return null;
  }
};

export const clearAdminProfile = () => {
  localStorage.removeItem(AUTH_USER_KEY);
};

export const hasAuthSession = () => Boolean(getAdminProfile());

export const clearAuthSession = () => {
  clearAdminProfile();
  localStorage.removeItem("admin_logged_in");
  localStorage.removeItem("admin_access_token");
  notifyAuthChange();
};
